<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    {{this.title | translate}}
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12>
                        <vue-plotly :white-mode="whiteMode" v-if="data1" disable-responsive :data="data1" :layout="layout1" :options="{}"/>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import {callAPI} from '@/helper'
    import VuePlotly from "../../components/VuePlotly";
    import smoothLine from "../../components/mixins/smoothLine";
    export default {
        props: {
          title: {type: String, default: 'Chiller Sequencing Profile - DTchw'},
          xTitle: {type: String, default: 'Building Cooling Load (kW)'},
          yTitle: {type: String, default: 'Temperature Δ (°C)'},
          dateRange: {type: Object, default: null},
            whiteMode:{type:Boolean, default: false},
        },
        name: 'ChillerSequencingDeltaWidget',
        components: {VuePlotly},
        mixins:[smoothLine],
        watch: {
          dateRange(){
            this.refresh()
          }
        },
        data () {
            return {
                menu:false,
                loading:true,
                data1:null,
                timeout:null,
                layout1:{
                    yaxis: {
                        title: this.$options.filters.translate(this.yTitle)
                    },
                    xaxis: {
                        title: this.$options.filters.translate(this.xTitle)
                    },
                    legend: {
                        orientation: 'h',
                        traceorder:'normal',
                        y:-0.2
                    },
                    showlegend:true,
                    hoverlabel: {
                        namelength: -1,
                    },
                    margin:{
                        l: 50,
                        r: 50,
                        t: 50,
                        pad: 1
                    },
                },
            }
        },
        mounted() {
            this.refresh();
        },
        methods:{
            debounce(callback, wait) {
                clearTimeout(this.timeout);
                this.timeout= setTimeout(() => callback(), wait);
            },
            refresh(){
                this.debounce(this.getData,500);
            },
            getData(){
                let me=this;
                me.loading=true
                let currentRange=[me.dateRange.start, me.dateRange.end]
                let chillers=[]
                for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                    if(equip.equipment_type.toLowerCase().startsWith('chiller')){
                        let allSensors=this.$store.state.pointsListStore.pointsList.sensors[i]
                        if(allSensors.indexOf("Cooling_Load")>-1){
                            chillers.push(equip.equipment_name)
                        }
                    }
                }
                callAPI('stagingprofile/',{
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    date_range:currentRange,
                    equipment_names:chillers,
                    'extra_vars': [{
                        'equipment_name': 'Chilled_Water_Header',
                        'sensor_names': ['Header_Chilled_Water_Delta_T']
                    }]
                }).then(function(result){
                    let data1=[]
                    let m=0
                    let options = {span: 0.6, band: 0.8, degree: 1}
                    let colorList = ['#1f77b4',  // muted blue
                        '#ff7f0e',  // safety orange
                        '#2ca02c',  // cooked asparagus green
                        '#d62728',  // brick red
                        '#9467bd',  // muted purple
                        '#8c564b',  // chestnut brown
                        '#e377c2',  // raspberry yogurt pink
                        '#7f7f7f',  // middle gray
                        '#bcbd22',  // curry yellow-green
                        '#17becf']
                    for (let index in result.data.result){
                        let x=result.data.result[index].Cooling_Load
                        let y=result.data.result[index]['Header_Chilled_Water_Delta_T']
                        let index1 = index.replace(/[{}]/g, "")
                        if(x&&x.length>10&&y&&y.length>10){
                          data1.push({
                                name: index1,
                                x:x,
                                y:y,
                                mode:'markers',
                                marker: {
                                    color: colorList[m % 10]
                                },
                            })
                            let cleanedX=[]
                            let cleanedY=[]
                            for(let i in x){
                                if(x[i]>0&&y[i]>0){
                                    cleanedX.push(x[i])
                                    cleanedY.push(y[i])
                                }
                            }
                            let smooth = me.smoothLineLoess(cleanedX, cleanedY, 50, options)
                            data1.push({
                                line: {
                                    color: colorList[m % 10]
                                },
                                x: smooth.data['x'],
                                y: smooth.fitted['fitted'],
                                mode: 'lines',
                                name: 'Smoothed Line of ' + index1,
                            })
                          m++
                        }
                    }
                    me.data1=data1
                    me.loading=false
                })
            }
        },
    }
</script>
